export interface CompanyModel {
  companyId: number;
  companyName: string;
}
